import { Link } from 'react-router-dom';
import PolicyLayout from '../components/PolicyLayout';
import { COMPANY_NAME, PRODUCT_NAME, SITE_DOMAIN, SITE_NAME, TRADEMARK_OWNERS } from '../constants/site';

export default function DisclaimerPage() {
  return (
    <PolicyLayout title="Disclaimer" intro={`Important information about the independent nature of ${SITE_DOMAIN}.`}>
      <h2>Independent support provider</h2>
      <p>
        {SITE_NAME} is operated by {COMPANY_NAME}, an independent third-party technical support company.
        We are <strong>not</strong> affiliated with, endorsed by, sponsored by, or in any way officially
        connected with {TRADEMARK_OWNERS}, or any of their subsidiaries or affiliates.
      </p>

      <h2>Trademarks</h2>
      <p>
        {PRODUCT_NAME} and all other product names, logos, and brands mentioned on this website are the
        property of their respective owners. They are used for identification purposes only and do not
        imply endorsement.
      </p>

      <h2>Official support</h2>
      <p>
        The software publisher may offer its own support, in some cases free of charge. You are always free
        to contact the publisher directly instead of using our service.
      </p>

      <h2>Information accuracy</h2>
      <p>
        Our guides are written in good faith for general information. Software changes over time, and
        menus or features may differ on your system. We are not responsible for loss of data resulting
        from following general guidance — always make a backup before making changes.
      </p>

      <h2>Paid services</h2>
      <p>
        Some one-to-one support services may carry a fee, which is always disclosed and agreed before work
        begins. See our <Link to="/terms-and-conditions">Terms &amp; Conditions</Link> and{' '}
        <Link to="/refund-policy">Refund Policy</Link>.
      </p>
    </PolicyLayout>
  );
}
